export default "__VITE_ASSET__CWYhkqvm__"